const WORDS = ["SOFTWAREOPTIMIERUNG", "AGR / DPF / SCR", "STEUERGERÄTE KLONEN", "ÖLDRUCK FIX", "STAGE 1 – 2+"];

export const MarqueeStrip = () => (
  <div className="relative py-8 md:py-10 border-y border-white/5 bg-brand-surface overflow-hidden">
    <p className="sr-only">{WORDS.join(" · ")}</p>
    <div className="marquee-track" aria-hidden="true">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {WORDS.map((word) => (
            <span key={word} className="mx-6 font-display font-black text-3xl md:text-5xl uppercase text-stroke flex items-center whitespace-nowrap">
              {word}<span className="text-brand ml-12 text-xl">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
